import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { setOffset } from 'redux/modules/navigationOffset'

import Module from 'ui/components/Module'

import AppShowcase from 'ui/components/modules/AppShowcase'
import BodyText from 'ui/components/modules/BodyText'
import BodyTextColumns from 'ui/components/modules/BodyTextColumns'
import Callout from 'ui/components/modules/Callout'
import Distance from 'ui/components/modules/Distance'
import DocumentList from 'ui/components/modules/DocumentList'
import DocumentSearch from 'ui/components/modules/DocumentSearch'
import Download from 'ui/components/modules/Download'
import Downloads from 'ui/components/modules/Downloads'
import FAQ from 'ui/components/modules/FAQ'
import FeaturedLinks from 'ui/components/modules/FeaturedLinks'
import FixedImageAndText from 'ui/components/modules/FixedImageAndText'
import Focus from 'ui/components/modules/Focus'
import Gallery from 'ui/components/modules/Gallery'
import Header from 'ui/components/modules/Header'
import HeaderText from 'ui/components/modules/HeaderText'
import HeaderVideo from 'ui/components/modules/HeaderVideo'
import Hero from 'ui/components/modules/Hero'
import Highlight from 'ui/components/modules/Highlight'
import ImageAndText from 'ui/components/modules/ImageAndText'
import LeadIn from 'ui/components/modules/LeadIn'
import Locations from 'ui/components/modules/Locations'
import Newsletter from 'ui/components/modules/Newsletter'
import PressMaterials from 'ui/components/modules/PressMaterials'
import ProductLandingGallery from 'ui/components/modules/ProductLandingGallery'
import ProductLandingHero from 'ui/components/modules/ProductLandingHero'
import ProductLandingVideo from 'ui/components/modules/ProductLandingVideo'
import Products from 'ui/components/modules/Products'
import Quote from 'ui/components/modules/Quote'
import ScrollAnchor from './modules/ScrollAnchor/index'
import TryBeforeYouBuy from 'ui/components/modules/TryBeforeYouBuy'
import TwoColumnText from 'ui/components/modules/TwoColumnText'
import VideoPlaylist from 'ui/components/modules/VideoPlaylist'
import VideoPlaylistYouTube from 'ui/components/modules/VideoPlaylistYouTube'
import LandingPageHero from 'ui/components/modules/LandingPageHero'
import LandingPageColumns from 'ui/components/modules/LandingPageColumns'
import YoutubeVideo from 'ui/components/modules/YoutubeVideo'
import Map from 'ui/components/modules/Map'
import Leds from 'ui/components/modules/Leds'
import ProductsNew from 'ui/components/modules/ProductsNew'
import ProductPage from 'ui/components/modules/ProductPage'
import Gatekeeper from 'ui/components/modules/Gatekeeper'
import Key from 'ui/components/modules/Key'
import Salesmen from 'ui/components/modules/Salesmen'
import ContactMenu from 'ui/components/modules/ContactMenu'
import ContactForm from './modules/ContactForm/index'
import CustomButton from './modules/Button'
import ContactVideo from './modules/TextVideo'
import SomeButtons from './modules/SomeButtons'
import IndustryHero from './modules/IndustryHero/index'
import IndustryProducts from './modules/IndustryProducts/index'
import CategoriesButtons from './modules/CategoriesButton/index'
import SensorButtons from './modules/SensorButtons/index'
import DealerSelector from './modules/DealerSelector'
import JpnHero from './modules/JpnHero/index'
import JpnProductFront from './modules/JpnProductFront/index'
import JpnCategories from './modules/JpnCategories/index'
import JpnIconButton from './modules/JPNIconButton/index'
import TechnicalInfoTable from './modules/TechnicalInfoTable/index'

const Wrapper = styled.div`
  background-color: #fff;
`;

const Missing = styled.div`
  padding: 30px;
  font-size: 18px;
`

class Modules extends Component {
  componentDidUpdate() {
    this.getOffset()
  }

  componentDidMount() {
    this.getOffset()
  }

  getOffset() {
    const { modules, setOffset } = this.props
    const windowHeight = typeof window !== undefined ? window.innerHeight : 0

    switch (modules[0].layout) {
      case 'hero':
      case 'productLandingHero':
        setOffset(windowHeight * 0.2)
        break

      case 'header':
      case 'headerVideo':
        setOffset(windowHeight * 0.1)
        break

      default:
        setOffset(0)
        break
    }
  }

  getModules() {
    const { modules } = this.props

    return modules.map((module, index) => {
      const key = index + '-' + module.layout

      switch (module.layout) {
        case 'bodyText':
          return <BodyText {...module} />
        case 'bodyTextColumns':
          return <BodyTextColumns {...module} />
        case 'distance':
          return <Distance {...module} />
        case 'documentList':
          return <DocumentList {...module} />
        case 'documentSearch':
          return <DocumentSearch {...module} />
        case 'download':
          return <Download {...module} />
        case 'featuredLinks':
          return <FeaturedLinks {...module} />
        case 'gallery':
          return <Gallery {...module} />
        case 'header':
          return <Header {...module} />
        case 'headerText':
          return <HeaderText {...module} />
        case 'headerVideo':
          return <HeaderVideo {...module} />
        case 'hero':
          return <Hero {...module} />
        case 'highlight':
          return <Highlight {...module} />
        case 'imageAndText':
          return <ImageAndText {...module} />
        case 'leadIn':
          return <LeadIn {...module} />
        case 'locations':
          return <Locations {...module} />
        case 'newsletter':
          return <Newsletter {...module} />
        case 'products':
          return <Products {...module} />
        case 'quote':
          return <Quote {...module} />
        case 'faq':
          return <FAQ {...module} />
        case 'downloads':
          return <Downloads {...module} />
        case 'twoColumnText':
          return <TwoColumnText {...module} />
        case 'productLandingHero':
          return <ProductLandingHero {...module} />
        case 'productLandingGallery':
          return <ProductLandingGallery {...module} />
        case 'productLandingVideo':
          return <ProductLandingVideo {...module} />
        case 'callout':
          return <Callout {...module} />
        case 'focus':
          return <Focus {...module} />
        case 'appShowcase':
          return <AppShowcase {...module} />
        case 'fixedImageAndText':
          return <FixedImageAndText {...module} />
        case 'videoPlaylist':
          return <VideoPlaylist {...module} />
        case 'videoPlaylistYouTube':
          return <VideoPlaylistYouTube {...module} />
        case 'tryBeforeYouBuy':
          return <TryBeforeYouBuy {...module} />
        case 'scrollAnchor':
          return <ScrollAnchor {...module} />
        case 'pressMaterials':
          return <PressMaterials {...module} />
        case 'landingPageHero':
          return <LandingPageHero {...module} />
        case 'landingPageColumns':
          return <LandingPageColumns {...module} />
        case 'youtubeVideo':
          return <YoutubeVideo {...module} />
        case 'map':
          return <Map {...module} />
        case 'leds':
          return <Leds {...module} />
        case 'productsNew':
          return <ProductsNew {...module} />
        case 'productPage':
          return <ProductPage {...module} />
        case 'gatekeeper':
          return <Gatekeeper {...module} />
        case 'key':
          return <Key {...module} />
        case 'contact_salesmen':
          return <Salesmen {...module} />
        case 'contact_menu':
          return <ContactMenu {...module} />
        case 'contact_form':
          return <ContactForm {...module} />
        case 'button':
          return <CustomButton {...module} />
        case 'contact_video':
          return <ContactVideo {...module} />
        case 'some_buttons':
          return <SomeButtons {...module} />
        case 'industry_hero':
          return <IndustryHero {...module} />
        case 'industry_products':
          return <IndustryProducts {...module} />
        case 'categories_buttons':
          return <CategoriesButtons {...module} />
        case 'sensor_buttons':
          return <SensorButtons {...module} />
        case 'dealer_selector':
          return <DealerSelector {...module} />
        case 'jpn_hero':
          return <JpnHero {...module} />
        case 'jpn_product_front':
          return <JpnProductFront {...module} />
        case 'jpn_categories':
          return <JpnCategories {...module} />
        case 'jpn_icon_button':
          return <JpnIconButton {...module} />
        case 'technical_info_table':
          return <TechnicalInfoTable {...module} />
        default:
          return <Missing key={key}>Missing implementation of {module.layout}</Missing>
      }
    })
  }

  render() {
    return (
      <Wrapper>
        {this.getModules().map((module, index) => <Module key={index}>{module}</Module>)}
      </Wrapper>
    )
  }
}

export default connect(null, { setOffset })(Modules)



// WEBPACK FOOTER //
// ./src/ui/components/Modules.js